import type { FormVersion, SaveMode } from "../state/formVersion";
import { useFormVersionDispatch, useFormVersionState } from "../state/formVersion";
import type { SetStoreFunction } from "solid-js/store";
import { produce } from "solid-js/store";
import { initialized } from "../utils/initializedUtil";
import type { ThemeId } from "../types";
import type FieldId from "../fields/FieldId";
import { remove } from "lodash-es";

import type { StringTemplate } from "../utils/stringTemplateUtil";

let setFormVersionStore: SetStoreFunction<FormVersion> | null = null;
let formVersionStore: FormVersion | null = null;

const getFormVersionStore = () => initialized(formVersionStore, "formVersionStore");
const getSetFormVersionStore = () => initialized(setFormVersionStore, "setFormVersionStore");

const init = () => {
  setFormVersionStore = useFormVersionDispatch();
  formVersionStore = useFormVersionState();
};

const FormSettingsService = {
  init,

  getSettings: () => getFormVersionStore().settings,
  getSearchFields: () => getFormVersionStore().settings.searchSettings.fields,
  setSearchFields: (fields: FieldId[]) => {
    getSetFormVersionStore()("settings", "searchSettings", { fields });
  },
  getTheme: () => getFormVersionStore().theme,
  changeTheme: (value: ThemeId) => {
    getSetFormVersionStore()("theme", { id: value });
  },
  changeSaveMode: (value: SaveMode) => {
    getSetFormVersionStore()("settings", { saveMode: value });
  },
  changeDescriptionInApp: (value: StringTemplate) => {
    getSetFormVersionStore()("settings", { descriptionInApp: value });
  },
  enableSearch: (value: boolean) => {
    getSetFormVersionStore()(
      produce((state) => {
        state.settings.searchSettings.enabled = value;
      }),
    );
  },
  toggleAllowSearchingForAllSubmissions: (value: boolean) => {
    getSetFormVersionStore()(
      produce((state) => {
        state.settings.searchSettings.allowSearchingAllSubmissions = value;
      }),
    );
  },
  enableFiltering: (value: boolean) => {
    getSetFormVersionStore()(
      produce((state) => {
        state.settings.searchSettings.filteringEnabled = value;
      }),
    );
  },
  addToFilteredFields: (fieldId: FieldId) => {
    getSetFormVersionStore()(
      produce((state) => {
        state.settings.searchSettings.filteredFields.push(fieldId);
      }),
    );
  },
  removeFromFilteredFields: (fieldId: FieldId) => {
    getSetFormVersionStore()(
      produce((state) => {
        remove(state.settings.searchSettings.filteredFields, fieldId);
      }),
    );
  },
};

export default FormSettingsService;
